import * as React from 'react'
import { ModalBox } from '../ModalBox'
import { routeProvider } from '$utils/routeProvider'
import { Text } from '../Text'
import history from '$utils/history'
import { ErrorView } from './Error.model'
import { errors } from '$views/components/Error/serverErrors'

interface Props {
  error: ErrorView
  onClick: () => void
}

export const Error: React.SFC<Props> = ({ error, onClick }) => {
  const getOnClick = () => {
    if (error.type === 401) {
      return history.push(routeProvider.login)
    }

    if (error.text[0] === errors.invalid_user) {
      return history.push(routeProvider.login)
    }

    return onClick()
  }

  return (
    <ModalBox title={error.title} buttonLabel={'Aceptar'} onAcceptClick={() => getOnClick()} simple>
      {error.text.map((msgError, index) => (
        <Text key={index}>{msgError}</Text>
      ))}
    </ModalBox>
  )
}



// WEBPACK FOOTER //
// ./src/views/components/Error/Error.tsx